import {
  ITEMS_TYPE_CUSTOMER_ITEMS,
  ITEMS_TYPE_SHARED_BOARD
} from "../../../../../../constants";
import getSavedItems from "./getSavedItems";
import getSharedItems from "./getSharedItems";
import { getItemsType } from "../../../../common/selectors";

const operationMap = {
  [ITEMS_TYPE_CUSTOMER_ITEMS]: getSavedItems,
  [ITEMS_TYPE_SHARED_BOARD]: getSharedItems
};
const requestProvider = ({ state, params }) =>
  operationMap[getItemsType(state)]({ state, params });

export default requestProvider;
